import { Paper, Skeleton } from '@mui/material';

/**
 * Skeleton loader for stat cards used in dashboard pages
 *
 * @param {Object} props - Component props
 * @param {number} props.height - Card height (default: 140)
 */
const StatCardSkeleton = ({ height = 140 }) => (
  <Paper
    elevation={2}
    sx={{
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      minHeight: height,
    }}
  >
    <Skeleton variant="circular" width={40} height={40} sx={{ mb: 1 }} />
    <Skeleton variant="text" width={60} height={40} sx={{ mb: 0.5 }} />
    <Skeleton variant="text" width={100} height={20} />
  </Paper>
);

export default StatCardSkeleton;
